import * as React from "react";
import { PageProps } from "../../../core/ui/pages/Page";
import { ILegalViewCreationPresenter } from "../../presenter/LegalViewCreationPresenter";
import LegalViewCreationForm from "../components/LegalViewCreationForm";

export interface Props extends PageProps {}
export interface State extends ILegalViewCreationPresenter {}

export default class LegalViewCreationPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      organisations,
      legalViewTypes,
      organisationIndexes,
      legalViewTypeId,
      setOrganisationId,
      translate,
      createLegalView,
      showLegalViewList,
      user,
      setLegalViewTypeId,
      selectedOrganisationId,
      store
    } = this.state;
    return (
      <LegalViewCreationForm
        translate={translate}
        showLegalViewList={showLegalViewList}
        legalViewTypes={legalViewTypes}
        organisations={organisations}
        setOrganisationId={setOrganisationId}
        organisationIndexes={organisationIndexes}
        legalViewTypeId={legalViewTypeId}
        onSubmit={createLegalView}
        user={user}
        setLegalViewTypeId={setLegalViewTypeId}
        selectedOrganisationId={selectedOrganisationId}
        store={store}
      />
    );
  }
}
